import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA3E0JdXUOpLdMBbxRZyRF0DfBj4g4AjaI",
  authDomain: "vndr-9dadb.firebaseapp.com",
  projectId: "vndr-9dadb",
  storageBucket: "vndr-9dadb.firebasestorage.app",
  messagingSenderId: "646272593594",
  appId: "1:646272593594:web:4535d32910ff7f6a5e9c83",
  //measurementId: "G-SHXTGCJYTJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;